// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"eb957a5c6a4fe624130d","404":"13cc8b912d740ca5edef","406":"46a83f3e8e4b34bb626b"}[chunkId] + ".css";
};